import script from "./month-year-selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./month-year-selector.vue?vue&type=script&setup=true&lang=ts"

import "./month-year-selector.vue?vue&type=style&index=0&id=478ad4d6&lang=postcss"

const __exports__ = script;

export default __exports__